import { getCip30Wallet } from "@sundae/wallets";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { Actions, useWalletContext } from "../store";
import { displayError } from "../utils/displayError";
import { useHeartbeatLogger } from "./useHeartbeatLogger";
const HOOK_CONTEXT = "useGetWalletApi";
let apiRef;
export const useWalletApi = () => {
    const { state: { activeWallet }, dispatch, } = useWalletContext();
    const hb = useHeartbeatLogger();
    const { mutateAsync: connectApi, ...rest } = useMutation(["cardano.api", activeWallet], async ({ overrideWallet }) => {
        hb.logCheckingWallet(HOOK_CONTEXT);
        const freshApi = getCip30Wallet(overrideWallet || activeWallet);
        if (freshApi) {
            apiRef = await freshApi.enable();
        }
        else {
            hb.logNoWalletSet(HOOK_CONTEXT);
        }
        return apiRef;
    }, {
        onMutate: () => {
            apiRef = undefined;
        },
        onSuccess: async () => {
            if (!apiRef) {
                hb.logDoneWithoutChanges(HOOK_CONTEXT);
                return;
            }
            hb.logDoneWithChanges(HOOK_CONTEXT);
        },
        onError: async (e) => {
            console.log(e);
            await Actions.logout(dispatch);
            Actions.setError(await displayError(e), dispatch);
        },
    });
    const clearApi = useCallback(() => {
        apiRef = undefined;
    }, []);
    return {
        api: apiRef,
        clearApi,
        connectApi,
        initialized: Boolean(apiRef),
        query: rest,
    };
};
//# sourceMappingURL=useWalletApi.js.map